export default __webpack_public_path__ + "static/media/CNo.88-7.20d3f264.jpg";